import viLocale from "element-ui/lib/locale/lang/vi";
import { performanceVi } from "../temp/performance-vi";
import trans from "@/doc/lang/_vi.json";
import hom from "@/doc/hom/_vi.json";
import { langVi } from "../lgyLangs/vi";
import { fhbLangVi } from "../fhbLangs/vi";
import { lssLangVi } from "../lssLangs/vi";


const vi = {
  normal: "Bình thường",
  outsourcing: "Thuê ngoài",
  English: "Tiếng Anh",
  española: "Tiếng Tây Ban Nha",
  India: "Tiếng Hindi",
  authority: {
    createNewUser: "Tạo tài khoản mới",
    enterName: "Nhập tên tài khoản",
    enterEmail: "Nhập địa chỉ E-mail",
    enterRole: "Nhập vai trò",
    enterCountry: "Nhập Quốc Gia",
    enterID: "Nhập mã số nhân viên",
    enterPassword: "Nhập mật khẩu",
    password: "Mật khẩu",
    modifyPassword: "Sửa mật khẩu",
    oldPassword: "Mật khẩu gốc",
    newPassword: "Mật khẩu mới",
    confirmPassword: "Xác nhận mật khẩu mới",
    confirmTheChanges: "Xác nhận sửa đổi",
    ifForgotContactLeader: "Nếu quên mật khẩu, hãy liên hệ tổ trưởng",
    disaccordWithThFirsPassword: "Mật khẩu 2 lần đều không giống nhau",
    passwordRules: "Mật khẩu bao gồm chữ in hoa, chữ thường, số, ký tự, không chứa tên tài khoản, ít nhất 8 ký tự",
    name: "Tên",
    email: "E-mail",
    role: "Vai trò",
    country: "Quốc Gia",
    operator: "Người thao tác",
    operate: "Thao tác",
    Disable: "Vô hiệu",
    Enable: "Kích hoạt",
    enableGoogleVerification: "Bật xác minh google",
    requiredFields: "Thông tin cần thiết",
    pleaseFillInCorrectly: "Hãy nhập thông tin chính xác",
    edit: "Chỉnh sửa",
    delete: "Xóa",
    add: "Thêm",
    confirmDelete: "Xác nhận xóa?",
    cancel: "Hủy",
    ok: "Xác nhận",
    search: "Tìm kiếm Tổng hợp",
    operateTime: "Thời gian thao tác",
    roleManagement: "Quản lý vai trò",
    containsSubordinateLevelsAndCannotBeDeleted: "Có đính kèm cấp độ, không thể xóa",
    addaFirstLevelRole: "Thêm vai trò cấp một",
    roleRightsManagement: "Quyền hạn quản lý vai trò",
    permissionAssignment: "Điều phối quyền hạn",
    operationAuthority: "Quyền hạn thao tác",
    dataAuthority: "Quyền hạn dữ liệu",
    pleaseEnteraKeyword: "Hãy nhập từ khóa",
    passwordVerification: "Mật khẩu bao gồm chữ in hoa, chữ thường, chữ số, ký tự, không dùng tên của bạn để làm mật khẩu",
    passwordDoesNotContainCapitalLettersPleaseFillInAgain: "Mật khẩu chưa bao gồm chữ in hoa, vui lòng nhập lại",
    passwordDoesNotContainLowercaseLettersPleaseFillInAgain:
      "Mật khẩu chưa bao gồm chữ thường, vui lòng nhập lại",
    thePasswordDoesNotContainNumbersPleaseFillInAgain:
      "Mật khẩu chưa bao gồm chữ số, vui lòng nhập lại",
    passwordDoesNotContainCharactersPleaseFillInAgain:
      "Mật khẩu chưa bao gồm ký tự, vui lòng nhập lại",
    cantUseYourNameAsPasswordPleaseFillInAgain:
      "Không thể dùng tên của bạn để làm mật khẩu, vui lòng nhập lại",
    repeatPasswordPleaseFillInAgain: "Mật khẩu bị trùng, vui lòng nhập lại",
    disaccordWithTheFirstPassword: "2 lần nhập mật khẩu đều không khớp",
    mailboxAlreadyExistsPleaseFillInAgain: "Địa chỉ E-mail đã tồn tại, vui lòng nhập lại",
    theRoleContainsUsersAndCannotBeDeleted: "Vai trò chứa người dùng, không thể xóa",
    roleGroupManagement: "Quản lý nhóm vai trò",
    roleGroup: "Nhóm vai trò",
    createGroup: "Thiết lập nhóm",
    groupRoleAddedSuccessfully: "Đã thêm nhóm vai trò thành công",
    roleExistsInRoleGroupDeletionFailed: "Nhóm vai trò chứa vai trò, không thể xóa",
    groupPermissionManagement: "Quản lý quyền hạn nhóm",
    permissionAssignmentSucceeded: "Điều phối quyền hạn thành công",
  },
  collectWorkOrders: {
    ticketAtttibuteConfiguration: "Thiết lập kỳ hạn thanh toán",
    singlePeriodDays: "Thiết lập kỳ hạn thanh toán (số ngày)- một đợt",
    installmentDays: "Thiết lập kỳ hạn thanh toán (số ngày)- nhiều đợt",
    delete: "Xóa",
    save: "Lưu",
    addCustomWorkOrderLevels: "Thêm cấp bậc đơn hàng tùy chỉnh",
    areYouSureToDelete: "Xác nhận xóa thiết lập đơn hàng?",
    cancel: "Xóa",
    confirm: "Xác nhận",
    deleteAll: "Xóa toàn bộ",
    edit: "Chỉnh sửa",
    pleaseSetaCoherentLevel: "Vui lòng thiết lập cấp bậc liên tục",
    pleaseSetaDifferentLevel: "Vui lòng thiết lập cấp bậc khác nhau",
  },
  performance: {
    rollfinishnum: 'Roll Finish Num',
    staffPerformance: "Quản lý hiệu suất nhân viên",
    ticketCategory: "Phân loại đơn hàng",
    role: "Vai trò",
    time: "Chọn thời gian",
    staff: "Nhân viên",
    email: "E-mail",
    search: "Tìm kiếm",
    clear: "Xóa",
    refresh: "Tải mới",
    export: "Xuất",
    date: "Ngày tháng",
    ranking: "Xếp hạng",
    totalLeftUnpaidPrincipal: "Chia khoản vay gốc",
    repayPrincipal: "Nợ gốc đã trả",
    repayInterest: "Số tiền lãi đã trả",
    totalRepayAmount: "Tổng số tiền đã trả",
    repayRate: "Tỷ lệ thu hồi",
    targetRepayRate: "Kế hoạch thu hồi",
    diffTargetRepayAmount: "Số tiền chênh lệch",
    newAssignNum: "Phân bổ mới",
    handleTimes: "Số lần xử lý đơn hàng",
    handleNum: "Số đơn hàng xử lý",
    completeNum: "Số lượng hoàn thành",
    loadNum: "Số tải",
    performanceComparison: "Đối chiếu hiệu suất",
    type: "Phân loại đối chiếu hiệu suất",
    belongedGroup: "Thuộc nhóm",
    staffOptional: "Nhân viên (có thể chọn)",
    pleaseChoose: "Vui lòng chọn",
    YesNoLastorderrule: "Có phải đơn hàng được chia lần cuối",
    byStaff: "Theo nhân viên",
    byGroup: "Theo vai trò",
    byGroup1: "Theo vai trò",
    byGroup2: "Theo nhóm",
    byGroup3: "OM",
    pleaseChooseaRole: "Chọn một vai trò",
    noStaffsUnderThisGroupWereFoundPleaseConfirmWhetherTheGroupAndStaffMatches:
      "Chưa tìm ra thành viên nhóm, hãy xác nhận",
    dashboard: "dashboard",
    groupTotalRepayAmount: "Tổng số tiền nhóm trả",
    groupRepayRate: "tổng số tiền nhóm thu",
    groupKPI: "KPI nhóm",
    groupCompleteNum: "Số lượng nhóm hoàn thành",
    groupRanking: "Xếp hạng hiện tại của nhóm",
    group: "Nhóm",
    staffRanking: "Xếp hạng thành viên trong nhóm",
    name: "Họ và tên",
    newtab: "Tab mới",
    completeLabel: "Performance completed",
    completed: "selesai",
    inCompleted: "Bertahanlah di udara",
    repayAmount: 'Importe de la recaudación',
    repayTime: 'Tiempo de registro bancario',
    notifyTime: 'Tiempo de notificación bancaria',
    jsIndex: 'Número de serie',
    businessTime: 'Tiempo de notificación de la empresa'
  },
  performance2: {
    bucket: "Bucket",
    fecha: "Date",
    avgcalltime: "Avg Call Times",
    difcalltime: "Dif Call Times",
    avgrepayrate: "Avg Repay Rate",
    hourlyachievementsents: "Hourly Achievements Ents",
    totalallocationamount: "Total Allocation Amount",
    totalrepayamount: "Total Repay amount",
    hourlytarget: "Hourly Target",
    completerate: "Complete Rate"
  },
  orderInfo:{
    BadDebts:"Bad debts",
  },
  ticket: {
    normal: 'normal',
    abnormal:'anormal',
    PowerNuclearRemarks: "Nhận xét về năng lượng hạt nhân",
    PaymentCodeStatus: "Trạng thái mã thanh toán",
    PaymentCodeAmount: "Số tiền mã thanh toán",
    PaymentCode: "Mã thanh toán",
    ThirdPartyName: "Tên của Bên thứ ba",
    Mobile: "Số điện thoại",
    VA: "VA",
    OXXOCode: "Mã OXXO",
    PaynetCode: "Mã Paynet",
    AccountId: "Mã tài khoản",
    InvalidTime: "Thời gian vô hiệu",
    RemainingAmount: "Tổng số tiền phải trả",
    collectTicketSystem: "hệ thống mã thu hồi nợ",
    systemManager: "Quản lý đơn hàng",
    ticketID: "Mã số đơn hàng",
    loanID: "Mã số vay",
    userID: "Mã số người dùng",
    caseID: "caseID ",
    ticketAssignToName: "Đơn hàng được giao cho (name)",
    ticketAssignToId: "Đơn hàng được giao cho (id)",
    ticketCreateTime: "Thời gian tạo đơn hàng",
    completeTime: "Thời gian hoàn thành",
    closeTime: "Thời gian đóng",
    assignTime: "Thời gian giao",
    ticketStatus: "Trạng thái đơn hàng",
    ticketCategory: "Phân loại đơn hàng",
    search: "Tìm kiếm",
    batchAssign: "Phân bổ hàng loạt",
    emailNameExport: "Email List Export",
    batchRecover: "Thu hồi hàng loạt",
    batchOutsourcing: "Đơn hàng chuyển ra theo lô",
    batchRecall: "Batch Taking Back for Self Collection",
    dataExport: "Xuất dữ liệu",
    handleTime: "Số lần xử lý đơn hàng",
    lastCommunicationResult: "Thời gian xử lý lần trước",
    nextCommunicationResult: "Thời gian liên lạc lại",
    partialCompleteTime: "Thời gian hoàn thành một phần",
    expirationTime: "Thời gian hết hạn",
    operation: "Thao tác",
    attributeConfigure: "Cấu hình thuộc tính",
    ticketBasicAttribute: "Tính chất cơ bản đơn hàng",
    attributeNumber: "Mã số thuộc tính",
    attributeName: "Tên thuộc tính",
    foundTime: "Thời gian thiết lập",
    ticketCombineAttribute: "Thuộc tính nhóm đơn hàng",
    newAttributeValueOperation: "Tao thuộc tính + Giá trị hoạt động",
    newCombineAttributeOperation: "Tạo nhóm thao tác thuộc tính",
    combineName: "Tên nhóm thuộc tính",
    attributeOne: "Thuộc tính 1",
    calculate: "Tính toán",
    value: "Giá trị",
    attributeDetails: "Danh sách thuộc tính",
    updateTime: "Thời gian cập nhật",
    edit: "Phụ trách",
    loadAttributeConfigure: "Tải cấu hình thuộc tính",
    loadAttributeName: "Tên thuộc tính tải",
    attributeType: "Loại giá trị thuộc tính",
    combineAttributeNumber: "Nhãn tổ hợp thuộc tinh",
    attributeValue: "Giá trị thuộc tính",
    newTicket: "Đơn hàng mới",
    oldTicket: "Đơn hàng cũ",
    completeTicket: "Đã hoàn thành",
    telephone: "Điện thoại",
    customerName: "Tên họ khách hàng",
    dailyCollectionTimes: "Số lần đòi nợ mỗi ngày",
    collectionTimes: "Số lần đòi nợ",
    lastCollectionTime: "Thời gian đòi nợ lần trước",
    lastCollectionRecord: "Kết quả đòi nợ lần trước",
    promiseToPayTime: "Thời gian hứa trả nợ",
    customerType: "Phân loại khách hàng",
    overdueDays: "Số ngày quá hạn",
    timeSinceLastProcessing: "Cách thời gian xử lý lần trước",
    collection: "Đòi nợ",
    ticketInfo: "Thông tin đơn hàng",
    LatestPromisedRepaymentTime: "Thời gian hứa trả lần trước",
    customerDetailInformation: "Chi tiết khách hàng",
    SMS: "Tin nhắn",
    sendMessageToCustomer: "Gửi tin nhắn cho khách hàng",
    sendMessageToCustomer2: "Gửi tin nhắn cho SĐT thứ 2 của người dùng",
    sendMessageToContactOne: "Gửi tin nhắn cho người liên hệ 1",
    sendMessageToContactTwo: "Gửi tin nhắn cho người liên hệ 2",
    sendMessageToContactThree: "Gửi tin nhắn cho người liên hệ 3",
    selectMessage: "Hãy chọn mẫu tin nhắn",
    send: "Gửi",
    phone: "Điện thoại",
    phoneTwo: "Số điện thoại thứ hai",
    contact1phone: "Người liên hệ 1- điện thoại",
    relationship: "Liên hệ",
    name: "Họ và tên",
    contact2phone: "Người liên hệ 2- điện thoại",
    contact3phone: "Người liên hệ 3- điện thoại",
    familyPhone: "Điện thoại nhà",
    autoCallResult: "Kết quả cuộc gọi tự động",
    logCollectionDetails: "Lưu lại kết quả đòi nợ",
    relief: "Miễn giảm",
    contactWay: "Phương thức liên hệ",
    contactTime: "Thời gian gọi",
    targetContact: "Đối tượng gọi",
    connection: "Tình trạng kết nối cuộc gọi",
    willingnessToPay: "Dự định trả nợ",
    overdueReason: "Nguyên nhân quá hạn",
    collectionResult: "Kết quả đòi nợ",
    remark: "Ghi chú",
    saveCollectionDetail: "Lưu giữ lịch sử đòi nợ",
    repaymentInfo: "Thông tin trả nợ",
    VAaccount: "Tài khoản VA",
    OXXOMarketPaymentCode: "Mã thanh toán cửa hàng tiện lợi OXXO",
    PaynetMarketPaymentCode: "Mã thanh toán cửa hàng tiện lợi Paynet",
    remainingAmountDue: "Số tiền phải trả",
    marketPayAmount: "Số tiền mã trả nợ của cửa hàng tiện lợi",
    OXXOMarketPaymentCodeAmount: "Số tiền mã trả nợ của cửa hàng tiện lợi OXXO (bao gồm phí thủ tục)",
    PaynetMarketPaymentCodeAmount: "Số tiền mã trả nợ của cửa hàng tiện lợi Paynet (bao gồm phí thủ tục)",
    refreshOXXOMarketPaymentCode: "Cập nhật Số tiền mã thanh toán của cửa hàng tiện lợi",
    OXXONeedFee: "OXXO trả nợ, khách hàng còn phải trả phí thủ tục",
    PaynetNeedFee: "Paynet trả nợ, khách hàng còn phải trả phí thủ tục",
    PaycashNeedFee: "Paycash trả nợ, khách hàng còn phải trả phí thủ tục",
    BalotoNeedFee: "Vía Baloto trả nợ, khách hàng còn phải trả phí thủ tục",
    EfectyNeedFee: "Efecty trả nợ, khách hàng còn phải trả phí thủ tục",
    BancolombiaNeedFee: "Bancolombia trả nợ, khách hàng còn phải trả phí thủ tục",
    HandlingFee: "fuc",
    LoanInfo: "Thông tin vay tiền",
    RemainingAmountDue: "Tổng số tiền còn lại phải trả",
    OverdueDays: "Số ngày quá hạn",
    ActualRepaymentAmount: "Tổng số tiền thực phải trả",
    TotalRepaymentAmount: "Tổng số tiền đơn hàng",
    CollectionStaff: "Người nhắc nhở",
    TargetContact: "Đối tượng gọi",
    CommunicationTools: "Phương thức đòi nợ",
    Contact: "Điện thoại liên hệ",
    ContactTime: "Thời gian gọi",
    answerTime: "Thời gian trả lời",
    endTime: "Thời gian kết thúc",
    hangupDirection: "Hướng cúp máy",
    hangupCause: "Nguyên nhân cúp máy",
    isNotConnect: "Có gọi được hay không?",
    PromiseToPayTime: "Thời gian hứa trả nợ",
    WillingnessToRepay: "Ý định trả nợ",
    CollectionResult: "Lý do chưa gọi được",
    record: "Kết thúc",
    DueDate: "Ngày phải trả nợ",
    Principal: "Số tiền vốn phải trả",
    ReceivedRepaymentOfPrincipal: "Số tiền lãi đã trả",
    GracePeriodInterest: "Số tiền lãi gia hạn",
    ReceivedRepaymentOfGracePeriodInterest: "Số tiền lãi gia hạn đã trả",
    PenaltyAndExtraFeesThatShouldBePaid: "Số tiền phạt phải trả",
    ReceivedRepaymentOfPenalty: "Số tiền phạt đã trả",
    autoCallTime: "Thời gian gọi tự động",
    Nickname: "Nickname",
    OnlineOrNot: "Có online hay không",
    AreYouSure: "Đã xác nhận chưa?",
    Sure: "Xác nhận",
    Cancel: "Hủy",
    DeductionOfPrincipal: "Miễn giảm tiền vốn",
    InterestReduction: "Miễn giảm tiền lãi",
    RecordCollectionResults: "Lưu lại kết quả đòi nợ",
    Connect: "Đã kết nối",
    NotConnected: "Chưa kết nối",
    LoanOrderNumber: "Mã số đơn hàng vay",
    Collection: "Tình trạng đòi nợ",
    PaymentRecord: "Payment Record",
    RepaymentPlan: "Kế hoạch trả nợ",
    AutomaticOutgoingCallRecord: "Lịch sử cuộc gọi tự động",
    RecordCollectionRecord: "Lưu lại lịch sử đòi nợ",
    RepaymentIssueReport: "Báo cáo vấn đề thanh toán",
    ApplyForInterestFreeze: "Apply for an interest freeze",
    CommitmentRepaymentTime: "Thời gian hứa trả nợ",
    Reminder: "Người nhắc nhở",
    CallObject: "Đối tượng gọi",
    CollectionMethod: "Phương thức đòi nợ",
    ContactNumber: "Điện thoại liên hệ",
    PhoneCallTime: "Thời gian gọi",
    ResponseTime: "Thời gian trả lời",
    EndTime: "Thời gian kết thúc",
    OnhookDirection: "Hướng cúp máy",
    ReasonForHangingUp: "Nguyên nhân cúp máy",
    WhetherToDial: "Có gọi được hay không?",
    ReasonForNotReturning: "Lý do chưa trả",
    ReasonForNotConnecting: "Nguyên nhân chưa gọi được",
    Result: "kết quả",
    Recording: "Lưu lại",
    AutomaticOutgoingTime: "Thời gian gọi tự động",
    WhetherToCommunicate: "Có chịu thỏa thuận hay không?",
    EnterThePartialRepaymentAmount: "Nhập số tiền khách hàng đã thỏa thuận trả",
    Attention: "Chú ý",
    RemainingAmountOfTheOrder: "Tổng số tiền còn lại phải trả",
    OrderId: "Mã đơn hàng",
    ActualPaymentDate: "Ngày thực trả nợ",
    ActualRepaymentPrincipal: "Tổng số tiền vốn thực trả",
    RemissionDay: "Ngày miễn giảm",
    ReferralDirector: "Đã giảm tiền vốn",
    TheRemainingPrincipalCanBeReduced: "Tổng số tiền vốn có thể giảm còn lai",
    Reason: "Nguyên nhân",
    ActualInterestPaidDuringGracePeriod: "Số tiền lãi gia hạn phải trả",
    PenaltyInterestActuallyPaid: "Số tiền phạt phải trả",
    GracePeriodInterestRemissiond: "Đã miễn giảm tiền lãi gia hạn",
    RemissiondPenaltyInterest: "Đã miễn giảm tiền phạt",
    TheRemainingPenaltyInterestCanBeRemission: "Tổng số tiền phạt có thể giảm",
    RemissionOfGracePeriodInterest: "Giảm miễn tiền lãi gia hạn",
    RemainingDeductibleInterestFromTheGracePeriod: "Tổng số tiền lãi có thể miễn giảm",
    auditResults: "Kết quả xét duyệt",
    auditor: "Nhân viên xét duyệt",
    ticketHandleTime: "Thời gian xử lý đơn hàng",
    ticketCompleteTime: "Thời gian hoàn thành xét duyệt",
    closeReason: "Lý do đóng",
    viewTicket: "Xem đơn hàng",
    repayStatus: "Estado de presentación de informes",
    repayStatus0: "Masalah pembayaran harus ditangani oleh CS",
    repayStatus1: "Menunggu verifikasi bank / pihak ketiga",
    repayStatus2: "Problema de reembolso de carga"
  },
  Dialer: {
    userName: "Họ tên người dùng",
    extnumber: "Số máy phụ",
    assignStatus: "Trạng thái điều phối",
    assigned: "Đã điều phối",
    unassigned: "Chưa điều phối",
    assign: "chỉ định",
    assignHistory: "chỉ định lịch sử",
    supplier: "Nhà cung cấp",
    InquiryExtensionNumberStartRange: "Phạm vi bắt đầu Kiểm tra số máy phụ",
    InquiryExtensionNumberEndRange: "Phạm vi kết thúc Kiểm tra số máy phụ",
    addTime: "Thêm thời gian",
    addTheExtensionNumber: "Thêm số máy phụ",
    deleteExtensionNumber: "Xóa số máy phụ",
    submit: "Nộp",
    roleList: "Danh sách vai trò",
    unassign: "Hủy điều phối",
    assignStaff: "Nhân viên điều phối",
    staffID: "Mã nhân viên",
    assignTime: "Thời gian điều phối",
    unassignTime: "Hủy thời gian điều phối",
    calledNumber: "Số đích",
    explicitNumber: "Hiển thị số",
    creationTime: "Tạo thời gian",
    outboundTime: "Thời gian gọi",
    outboundChannels: "Kênh gọi",
    talkTime: "Thời gian gọi",
  },
  systemAttribute: {
    attributeName: "Tên thuộc tính",
    attributeDescription: "Mô tả thuộc tính",
    parameterValue: "Giá trị thuộc tính",
    submit: "Nộp",
    NewSystemParameters: "Thêm tham số hệ thống",
  },
  phoneVerify: {
    workStatus: "trạng thái công việc",
    batchOperations: "thao tác hàng loạt",
    orderTime: "thời gian nhận đơn",
    PVCommissioner: "Chuyên viên PV",
    IRCommissioner: "Chuyên viên IR",
    batchOrders: "nhận đơn hàng loạt",
    batchStopOrders: "dừng đơn hàng loạt",
    stopAcceptTicket: "Tạm dừng nhận đơn",
    continueAcceptTicket: "Khôi phục nhận đơn"
  },
  userInfo: {
    identityInformation: "Thông tin cá nhân",
    name: "Họ tên khách hàng",
    gender: "Giới tính",
    IDType: "Phân loại giấy tờ",
    IDNumber: "Số CMND/ CCCD",
    mobileNumber: "Số điện thoại",
    email: "E-mail",
    versionName: "Số phiên bản ứng dụng",
    versionCode: "Số phiên bản trong GP",
    imageData: "Dữ liệu hình ảnh",
    IDPhoto: "Ảnh CMND/ CCCD",
    handheldPhoto: "Ảnh cầm CMND/ CCCD",
    otherInformation: "Các thông tin khác",
    personalInfomation: "Thông tin cá nhân",
    marriageStatus: "Hôn nhân",
    birthday: "Ngày tháng năm sinh",
    numberOfChildren: "Có mấy đứa con",
    currentAddress: "Địa chỉ hiện tại",
    detailAddress: "Địa chỉ chi tiết",
    educationStatus: "Giáo dục",
    famialyPhone: "Điện thoại nhà",
    disbursementType: "Phương thức nhận tiền",
    bankName: "Tên ngân hàng",
    bankNumber: "Số thẻ ngân hàng",
    workInformation: "Thông tin nghề nghiệp",
    workType: "Ngành nghề",
    monthlyIncome: "Thu nhập mỗi tháng",
    lengthOfWork: "Thời gian công tác",
    companyPhoneNumber: "Điện thoại công ty",
    companyName: "Tên công ty",
    companyAddress: "Công ty thuộc thành phố (tỉnh, thị trấn)",
    salaryDay: "Ngày lãnh lương",
    contactInformation: "Thông tin người liên hệ",
    contact1Name: "Tên họ người liên hệ 1",
    contact1Relationship: "Quan hệ người liên hệ 1",
    phone: "Điện thoại",
    contact2Name: "Họ tên người liên hệ 2",
    contact2Relationship: "Quan hệ người liên hệ 2",
    communicationTime: "Thời gian trao đổi",
    communicator: "Người trao đổi",
    contents: "Nội dung trao đổi",
    remark: "Ghi chú",
    loanHistory: "Mã số khoản vay",
    loanAmount: "Số tiền vay",
    loanTerms: "Người trao đổi",
    loanStatus: "Trạng thái vay",
    applyTime: "Thời gian đăng ký",
    processingTime: "Thời gian phê duyệt",
    loanTime: "Thời gian giải ngân",
    closingTime: "Thời gian thanh toán hết",
    overdueDays: "Số ngày quá hạn",
    ChangeHistory: "Lịch sử thay đổi",
    BorrowingHistory: "Lịch sử vay",
    AccountNumber: "Tài khoản",
    UpdateItems: "Mục cập nhật",
    OriginalValue: "Giá trị gốc",
    TheCurrentValue: "Gía trị hiện tại",
    TimeChange: "Thời gian chỉnh sửa",
    ModifiedBy: "Người chỉnh sửa",
    TheTerm: "Kỳ hạn",
    State: "Trạng thái",
    BillingMessage: "Thông tin nhận tiền",
  },
  menu: {
    PaymentCodeList: "Danh sách mã trả nợ",
    PaymentCodeHistory: "Lịch sử mã trả nợ",
    AuthoritySystem: "Quyền hạn hệ thống",
    UserManagement: "Quản lý người dùng",
    RoleManagement: "Quản lý vai trò",
    AuthorityManagement: "Quản lý quyền hạn",
    RolegroupManagement: "Quản lý nhóm vai trò",
    GroupRightsManagement: "Quản lý quyền hạn nhóm",
    SystemParameterConfiguration: "Tham số cấu hình hệ thống",
    PhoneVerifySystem: "Gọi điện thoại kiểm tra",
    StaffManagement: "quản lý nhân sự",
    QuestionLibraryConfig: "Cấu hình thư viện câu hỏi kiểm tra",
    CaseClassification: "Phân loại trường hợp",
    CollectTicketSystem: "Hệ thống đòi nợ",
    TicketManage: "Quản lý đơn hàng",
    AttributeConfigure: "Cấu hình thuộc tính",
    TicketBasicAttribute: "Thuộc tính cơ bản đơn hàng",
    TicketCombineAttribute: "Thuộc tính nhóm đơn hàng",
    LoadAttributeConfigure: "Tải cấu hình thuộc tính",
    RuleConfiguration: "Cấu hình quy tắc",
    GenerationRule: "Quy tắc hình thành",
    DistributionRules: "Quy tắc điều phối",
    RecyclingRules: "Quy tắc thu hồi",
    OutsourcingRules: "Quy tắc thuê ngoài",
    WorkOrderProcessingList: "Danh sách xử lý đơn hàng",
    Collection: "Đòi nợ",
    RepaymentReminder: "Nhắc trả nợ",
    DialerManagement: "Quản lý Dialer",
    VoipManagement: "Quản lý voip",
    NxManagement: "Cấu hình NX",
    ExtensionManagement: "Quản lý máy phụ",
    PerformanceManagement: "Quản lý hiệu suất",
    PersonalPerformance: "Hiệu suất cá nhân",
    PersonalPerformance2: "Hourly Collection Data",
    PerformanceComparison: "Đối chiếu hiệu suất",
    DistributeHistory: "Lịch sử điều phối",
    CollectionSystem: "C2 hệ thống thu hồi nợ",
    callRecords: "Lịch sử cuộc gọi",
    PaymentCodeInquire: "Kiểm tra mã trả nợ",
    salaryReport: "Bảng lương",
    Applyapprove: "xin xét duyệt",
  },
  lang: {
    Spanish: "Español",
    Chinese: "中文",
    English: "English",
    Vietnam: "Tiếng Việt",
    Arabic:' بالعربية ',
    indo:"bahasa Indonesia",
  },
  v0703: {
    Caseid: "Mã số trường hợp",
    TicketOperate: "Thao tác đơn hàng",
    PleaseEnterOrSelectRole: "Hãy nhập và chọn vai trò",
    CreationTime: "Thời gian tạo lập",
    LoadAttributesName: "Tải tên thuộc tính",
    PleaseEnterOrSelectAnAttributes: "Hãy nhập hoặc chọn 1 thuộc tính",
    LoadAttributesNumber: "Tải mã số thuộc tính",
    LoadAttributesDescription: "Tải mô tả thuộc tính",
    LoadAttributesType: "Tải phân loại thuộc tính",
    CombinedPropertyName: "Tên nhóm thuộc tính",
    NumericalValue: "Giá trị",
    Options: "Tùy chọn",
    Time: "Thời gian",
    CrowdOrder: "Xếp hạng hiệu suất",
    Save: "Lưu",
    PleaseEnter: "Vui lòng nhập",
    TicketUnassign: "Hủy điều phối đơn hàng",
    ViopNumberUnassign: "Hủy điều phối số máy phụ",
    NewAddition: "Thêm",
    TicketAssignStaff: "Nhân viên điều phối đơn hàng",
    TicketStaffId: "Mã số nhân viên phụ trách đơn hàng",
    TicketUnassignTime: "Thời gian hủy thời gian điều phối",
    ByDay: "Tìm kiếm theo ngày",
    Hour: "Tìm kiếm theo giờ",
    ParameterValue: "Giá trị tham số",
  },
  v0707: {
    FirstsubsequentLoan: "Vay lần đầu/ vay lại",
    FirstLoan: "Vay lần đầu",
    Reloan: "Vay lại",
    Yes: "Đống ý",
    No: "Không",
  },
  annotation: {
    AnnotationManagement: "标注管理",
    AnnotationTicketManagement: "标注工单管理",
    AnnotationTicketList: "标注工单列表",
  },
  ...viLocale,
  ...performanceVi,
  ...JSON.parse(trans),
  ...JSON.parse(hom),
  ...langVi,
  ...fhbLangVi,
  ...lssLangVi
};

export default vi;
